import React, { ComponentPropsWithRef } from 'react'

type PropType = ComponentPropsWithRef<'button'>

export const PrevButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props

  return (
    <button
      type="button"
      {...restProps}
      style={{
        position: 'absolute',
        left: 'clamp(8px, 2vw, 16px)',
        top: '50%',
        transform: 'translateY(-50%)',
        backgroundColor: '#007bff',
        color: '#ffffff',
        borderRadius: '50%',
        width: 'clamp(40px, 8vw, 48px)',
        height: 'clamp(40px, 8vw, 48px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        cursor: 'pointer',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        zIndex: 10,
        transition: 'background-color 0.2s ease'
      }}
    >
      <svg style={{
        width: 'clamp(16px, 3vw, 24px)',
        height: 'clamp(16px, 3vw, 24px)'
      }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
      </svg>
      {children}
    </button>
  )
}

export const NextButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props

  return (
    <button
      type="button"
      {...restProps}
      style={{
        position: 'absolute',
        right: 'clamp(8px, 2vw, 16px)',
        top: '50%',
        transform: 'translateY(-50%)',
        backgroundColor: '#007bff',
        color: '#ffffff',
        borderRadius: '50%',
        width: 'clamp(40px, 8vw, 48px)',
        height: 'clamp(40px, 8vw, 48px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        cursor: 'pointer',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        zIndex: 10,
        transition: 'background-color 0.2s ease'
      }}
    >
      <svg style={{
        width: 'clamp(16px, 3vw, 24px)',
        height: 'clamp(16px, 3vw, 24px)'
      }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
      </svg>
      {children}
    </button>
  )
}

export const DotButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props

  return (
    <button
      type="button"
      {...restProps}
      style={{
        width: 'clamp(8px, 2vw, 12px)',
        height: 'clamp(8px, 2vw, 12px)',
        margin: '0 clamp(4px, 1vw, 8px)',
        borderRadius: '50%',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: '#d1d5db',
        transition: 'background-color 0.2s ease'
      }}
    >
      {children}
    </button>
  )
} 